import React, { useState } from "react";
import ChangeExchange from "./ChangeExchange";
import ChangeShipment from "./ChangeShipment";
import Message from "../Message";
// Bootstrap
import Modal from "react-bootstrap/Modal";
const SettingsModal = ({ method, show, onHide, lang }) => {
  const language = lang === "AR" ? "arabic" : "english";
  const dataTransalte = require(`../../../../translate/${language}/data.json`);

  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);

  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />

      <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="forget-pass-otp-form"
      >
        {method === "exchange" ? (
          <ChangeExchange
            dataTransalte={dataTransalte}
            onHide={onHide}
            lang={lang}
            setMessageResponse={setMessageResponse}
          />
        ) : method === "shipment" ? (
          <ChangeShipment
            dataTransalte={dataTransalte}
            onHide={onHide}
            lang={lang}
            setMessageResponse={setMessageResponse}
          />
        ) : (
          <div></div>
        )}
      </Modal>
    </>
  );
};

export default SettingsModal;
